import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import IconDuplicate from './icons/IconDuplicate';
import { Typography } from './Typography';
import { Button } from './Button';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    insuranceSquigglyContainer: {
      display: 'flex',
      alignItems: 'center',

      '& > :first-child': {
        marginRight: unit,
      },
    },
  });

const messages = defineMessages({
  copyInsuranceFormSquiggly: {
    id: 'components.v2.CopyInsuranceFromSquiggly.copyInsuranceFormSquiggly',
    defaultMessage: 'Copy insurance form squiggly',
  },
  copied: {
    id: 'components.v2.CopyInsuranceFromSquiggly.copied',
    defaultMessage: 'Copied!',
  },
});

const CopyInsuranceFromSquigglyComponent: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
  const [insuranceSquigglyCopied, setInsuranceSquigglyCopied] = useState(false);
  const { formatMessage } = useIntl();

  const handleCopy = () => {
    setInsuranceSquigglyCopied(true);
  };

  return (
    <CopyToClipboard text="{{system.url.insuranceVerificationUrl}}" onCopy={handleCopy}>
      <div className={classes.insuranceSquigglyContainer}>
        <Button icon={<IconDuplicate fontSize="small" />}>
          <Typography>{formatMessage(messages.copyInsuranceFormSquiggly)}</Typography>
        </Button>
        {insuranceSquigglyCopied && <Typography component="span">{formatMessage(messages.copied)}</Typography>}
      </div>
    </CopyToClipboard>
  );
};

export const CopyInsuranceFromSquiggly = withStyles(styles)(CopyInsuranceFromSquigglyComponent);
